/* eslint quote-props: ["error", "consistent"] */

const locale = {
  "DeleteUser": "Delete user",
  "Confirm": "Confirm",
  "Cancel": "Cancel",
};

export default locale;
